// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Tooltip_trigger__nNDnu","tooltip":"Tooltip_tooltip__GU0Nl"};